
/**
 * 강의 콘텐츠 유형
 */
export type GetApiCourses200ContentItemSectionsItemLecturesItemContentType = typeof GetApiCourses200ContentItemSectionsItemLecturesItemContentType[keyof typeof GetApiCourses200ContentItemSectionsItemLecturesItemContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiCourses200ContentItemSectionsItemLecturesItemContentType = {
  VIDEO: 'VIDEO',
  MARKDOWN: 'MARKDOWN',
  VIDEO_MARKDOWN: 'VIDEO_MARKDOWN',
  QUIZ: 'QUIZ',
  EXTERNAL_LINK: 'EXTERNAL_LINK',
  TEXT: 'TEXT',
  CODING: 'CODING',
} as const;
